<template>
  <BaseSection v-if="getCurrentStep>=step">
    <template #title>{{step}}. Update Add Ons</template>

    <template #content>

      <template v-for="(addon,index) in getAddonsView('addons')">
        <div :key="index" :class="`d-flex justify-space-between ${addon.state.color}`" v-if="addon.id">
          <div>{{addon.name}}</div>
          <div class="d-flex justify-end">
            <div>{{addon.price | formatCurrency}}</div> 
            <div class="font-weight-bold addon_state text-right">{{addon.state.text}}</div>
            <div v-if="addon.state.text === 'unavailable'">
              <v-tooltip top>
                <template v-slot:activator="{on,attrs}">
                  <v-icon v-bind="attrs" v-on="on" small>{{mdiHelpCircle}}</v-icon>
                </template>
                <span>This add on has been removed because it is no longer available</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </template>

    </template>
  </BaseSection>
</template>

<script>
  import { mdiHelpCircle } from '@mdi/js';
  import { mapGetters } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/ChangedSections/BaseSection';

  export default {

    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: {BaseSection},

    data() {
      return {
        mdiHelpCircle
      }
    },

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep','getSection','getPreviousAddons','getCurrentAddons','getAddonsView']),
    },

  }
</script>

<style lang="scss" scoped>

  .addon_state {
    width: 80px;
  }

</style>
